import {
  IMAGE_ASSIST_PENDING,
  IMAGE_ASSIST_FULFILLED,
  IMAGE_ASSIST_FAILED,
  IMAGE_ASSIST_CLEAR,
  IMAGE_ASSIST_APPLIED,
} from '../actions/actionTypes';

const initialState = {
  status: 'IDLE',
  analysisResult: null,
  applied: false,
  error: null,
  retryCount: 0,
  isRetry: false,
  modelUsed: null,
  workflowGuid: null,
  initialAnalysisResult: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case IMAGE_ASSIST_PENDING:
    return {
      ...state,
      status: 'LOADING',
      error: null,
      isRetry: !!action.payload?.isRetry,
      retryCount: action.payload?.isRetry ? state.retryCount + 1 : state.retryCount,
      workflowGuid: action.payload?.workflowGuid ?? state.workflowGuid,
    };

  case IMAGE_ASSIST_FULFILLED:
    return {
      ...state,
      status: 'SUCCESS',
      analysisResult: action.payload,
      modelUsed: action.payload?.modelUsed || null,
      // Preserved across retries so a later retry can still be compared to the original
      // (Flash Lite) result rather than the previous retry attempt.
      initialAnalysisResult: state.isRetry ? state.initialAnalysisResult : action.payload,
      applied: false,
      error: null,
    };

  case IMAGE_ASSIST_FAILED:
    return { ...state, status: 'ERROR', error: action.payload };

  case IMAGE_ASSIST_APPLIED:
    return { ...state, applied: true };

  case IMAGE_ASSIST_CLEAR:
    return { ...initialState };

  default:
    return state;
  }
};
